import Core from '../plugin-core-system/core.class.js';
import Iterator from '../helper/iterator.helper.js';
import DomAccess from '../helper/dom-access.helper.js';

export default class CsResponsiveTables extends Core {

  /**
   * init responsive behavior for tables
   * set a data attribute to each td with each th text
   * needed for mobile view of the table
   */
   initResponsiveTables() {
    const table = this.el;
    const ths = Array.from(table.querySelectorAll('thead th')).map(th => th.textContent);
    const thsLength = ths.length;
    const tds = DomAccess.querySelectorAll(table,'tbody td');

    Iterator.iterate(tds, function(td,key){
      if (ths[key % thsLength] !== undefined && ths[key % thsLength] !== '' ) {
        td.setAttribute('data-th', ths[key % thsLength]);
      }
    });
  }

  init() {
    this.initResponsiveTables();
  }
}
